export const BULK_PRINT_TIMEOUT_MS = 120000;
